import * as angular from 'angular';
import TagFilterBridge from './TagFilter/TagFilterBridge';
angular
  .module('flowingly.components')
  .component('tagFilter', TagFilterBridge);
